import { Controller } from "@hotwired/stimulus"

// Copies a value to the clipboard and briefly swaps the trigger's label.
// Wire on a button:
//   data-controller="clipboard"
//   data-clipboard-value-value="https://..."
//   data-clipboard-success-text-value="Copied"
//   data-action="click->clipboard#copy"
//   <span data-clipboard-target="label">Copy invite</span>
export default class extends Controller {
  static targets = ["label"]
  static values = {
    value: String,
    successText: { type: String, default: "Copied" },
    revertMs: { type: Number, default: 1500 },
  }

  async copy(event) {
    event?.preventDefault()
    try {
      await navigator.clipboard.writeText(this.valueValue)
    } catch (_) {
      return
    }

    if (!this.hasLabelTarget) return
    const original = this.labelTarget.textContent
    this.labelTarget.textContent = this.successTextValue
    clearTimeout(this._revertTimer)
    this._revertTimer = setTimeout(() => {
      this.labelTarget.textContent = original
    }, this.revertMsValue)
  }
}
